import React from "react";
import { Nav, Navbar, NavDropdown, Container } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import MenuLink from "./MenuLink";
import { HUB_QUIZZES } from "../../data/quizzes";
import "../../styles/Menu.css";

const initialsFor = (user, profile) => {
  const displayName =
    profile?.display_name ||
    profile?.first_name ||
    user?.user_metadata?.full_name ||
    user?.email ||
    "U";
  return displayName
    .split(/[ @.]/)
    .filter(Boolean)
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};

const Menu = () => {
  const { user, profile, roles, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // On the home page the menu floats transparently over the hero video and is
  // centered (one-component look). Every other page keeps the solid white navbar.
  const isHome = location.pathname === "/";

  const isLoggedIn = !!user;
  const userInitials = isLoggedIn ? initialsFor(user, profile) : "";

  // Clicking the dropdown TITLE (not an item) goes to the blog index.
  const handleBlogClick = (event) => {
    if (event.target.id === "blog-nav-dropdown") {
      event.preventDefault();
      navigate("/learn");
    }
  };

  return (
    <Navbar
      bg={isHome ? undefined : "white"}
      expand="lg"
      aria-label="Main navigation"
      className={isHome ? "menu-overlay" : ""}
    >
      <Container fluid className="custom-navbar-container">
        <Navbar.Brand as={Link} to="/">
          <span className="custom-logo" style={{ marginLeft: "3rem" }}>
            Sârv.
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/mission">About</Nav.Link>
            <Nav.Link as={Link} to="/atlas">
              Atlas
            </Nav.Link>

            <Nav.Link as={Link} to="/herbCategories">
              Medicinal Plants
            </Nav.Link>

            <NavDropdown
              title="Blog"
              id="blog-nav-dropdown"
              className="no-caret"
              onClick={handleBlogClick}
            >
              <NavDropdown.Item as="div">
                <MenuLink title="Medicinal Herbs" category="herbalism" />
              </NavDropdown.Item>
              <NavDropdown.Item as="div">
                <MenuLink title="Women's Health" category="womens-health" />
              </NavDropdown.Item>
              <NavDropdown.Item as="div">
                <MenuLink title="Mental Health" category="mental-health" />
              </NavDropdown.Item>
              <NavDropdown.Item as="div">
                <MenuLink title="Digestive System" category="digestive-health" />
              </NavDropdown.Item>
              <NavDropdown.Item as="div">
                <MenuLink title="Nutrition & Recipes" category="recipes" />
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/learn">
                All articles →
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="Quizzes"
              id="quizzes-nav-dropdown"
              className="no-caret"
            >
              {HUB_QUIZZES.map((quiz) => (
                <NavDropdown.Item key={quiz.slug} as={Link} to={quiz.path}>
                  {quiz.navLabel}
                </NavDropdown.Item>
              ))}
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/quizzes">
                All quizzes →
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/faq">FAQ</Nav.Link>

            {isLoggedIn ? (
              <NavDropdown
                title={
                  <div style={{ textAlign: "center" }}>
                    <div className="menu-dropdown">{userInitials}</div>
                  </div>
                }
                id="user-profile-dropdown"
                className="custom-center-dropdown"
              >
                {/* Services section — hidden for admins (they use the Admin
                    Dashboard instead). For affiliates, "Dashboard" points to
                    the affiliate dashboard since that's their main view. */}
                {!roles.isAdmin && (
                  <>
                    <b style={{ paddingLeft: "15px" }}>Services</b>
                    <NavDropdown.Item
                      as={Link}
                      to={roles.isAffiliate ? "/affiliate-dashboard" : "/explorer"}
                    >
                      Dashboard
                    </NavDropdown.Item>
                    {roles.isPremium && !roles.isAffiliate && (
                      <NavDropdown.Item as={Link} to="/diseaseCategories">
                        Personalized Remedies
                      </NavDropdown.Item>
                    )}
                  </>
                )}

                {/* Admin section. */}
                {roles.isAdmin && (
                  <>
                    <b style={{ paddingLeft: "15px" }}>Admin</b>
                    <NavDropdown.Item as={Link} to="/maral1362">
                      Admin Dashboard
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/admin/affiliate-applications">
                      Affiliate Applications
                    </NavDropdown.Item>
                  </>
                )}

                <hr />
                <NavDropdown.Item as={Link} to="/user-settings">
                  Settings
                </NavDropdown.Item>
                <hr />
                <NavDropdown.Item onClick={signOut}>
                  Sign Out
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link
                as={Link}
                to="/login"
                className="secondary-button d-flex justify-content-center align-items-center"
              >
                Login
              </Nav.Link>
            )}

            {!roles.isPremium && (
              <Nav.Link
                href="#"
                onClick={(e) => { e.preventDefault(); navigate("/start"); }}
                className="btn menu-button primary d-flex justify-content-center align-items-center"
              >
                Get Started
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Menu;
